export const TABS = ["Dashboard", "Creative", "Reports"];

export const PRICING_MODES = {
  FIXED: "fixed",
  PERCENTAGE: "percentage",
};

export const DEFAULT_PRICING_MODE = PRICING_MODES.FIXED;

export const TIMESTAMP_CUTOFF = '2026-07-01T00:00:00.000Z';
